import { render, staticRenderFns } from "./BigStat.vue?vue&type=template&id=0e1eaaf3&scoped=true&"
import script from "./BigStat.vue?vue&type=script&lang=js&"
export * from "./BigStat.vue?vue&type=script&lang=js&"
import style0 from "./BigStat.scss?vue&type=style&index=0&id=0e1eaaf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1eaaf3",
  null
  
)

export default component.exports